import React from 'react';
import styled from 'styled-components';

interface BarProps {
  children: React.ReactNode;
  isOpen?: boolean;
}

export const Bar: React.FC<BarProps> = ({ children, isOpen }) => (
  <BarContainer isOpen={isOpen}>{children}</BarContainer>
);

const BarContainer = styled.div<{ isOpen?: boolean }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: ${props => (props.isOpen ? '250px' : '50px')};
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  transition: width 0.3s ease-in-out;
  overflow: hidden;
`;
